import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PlaceContext } from '../contexts/PlaceContext';

const PlacePickerReroute = () => {
  const navigate = useNavigate();
  const { setPlaceId } = useContext(PlaceContext);
  const [searchParams] = useSearchParams();
  console.log(searchParams.get('place_id'));

  useEffect(() => {
    const query_place_id = searchParams.get('place_id');

    if (query_place_id) {
      localStorage.setItem('place_id', query_place_id);
      setPlaceId(query_place_id);
    } else {
      const place_id = localStorage.getItem('place_id');
      if (place_id) {
        navigate('/booking');
      } else {
        navigate('/pick-place');
      }
    }
  }, []);

  return <></>;
};

export default PlacePickerReroute;
